import HistoricalTransactionLog from "../ReportViews/Analysis/HistoricalTransactionLog";
import ReportDeviceUtilization from "../ReportViews/Analysis/ReportDeviceUtilization";
import ReportDrawerActivity from "../ReportViews/Analysis/ReportDrawerActivity";
import ReportGamePerformance from "../ReportViews/Analysis/ReportGamePerformance";
import ReportGamePerformanceWithVariants from "../ReportViews/Analysis/ReportGamePerformanceWithVariants";
import ReportRevenueByDayOfWeek from "../ReportViews/Analysis/ReportRevenueByDayOfWeek";
import ReportRevenueByDevice from "../ReportViews/Analysis/ReportRevenueByDevice";
import BingoAccount from "../ReportViews/Bingo/BingoAccount";
import BingoActiveProgressives from "../ReportViews/Bingo/BingoActiveProgressives";
import BingoActiveSites from "../ReportViews/Bingo/BingoActiveSites";
import BingoCharityInvoice from "../ReportViews/Bingo/BingoCharity";
import BingoDistributor from "../ReportViews/Bingo/BingoDistributor";
import BingoGameLog from "../ReportViews/Bingo/BingoGameLog";
import BingoJackpotWinners from "../ReportViews/Bingo/BingoJackpotWinners";
import BingoLBPMonthly from "../ReportViews/Bingo/BingoLBPMonthly";
import BingoProgressiveContribution from "../ReportViews/Bingo/BingoProgressiveContribution";
import ReportBingoPerformance from "../ReportViews/Bingo/ReportBingoPerformance";
import ReportBingoPlay from "../ReportViews/Bingo/ReportBingoPlay";
import ReportCharitiesProgressiveContribution from "../ReportViews/Bingo/ReportCharitiesProgressiveContribution";
import DailySalesDetail from "../ReportViews/Financial/DailySalesDetail";
import LargeCashOut from "../ReportViews/Financial/LargeCashout";
import LocationLG861e from "../ReportViews/Financial/LocationLG861e";
import MonthlyReports from "../ReportViews/Financial/MonthlyReports";
import PeriodRevenue from "../ReportViews/Financial/PeriodRevenue";
import ReportCashierActivity from "../ReportViews/Financial/ReportCashierActivity";
import ReportDailyDeposit from "../ReportViews/Financial/ReportDailyDeposit";
import ReportDailyDepositSales from "../ReportViews/Financial/ReportDailyDepositSales";
import HistoricalInventory from "../ReportViews/Pulltabs/HistoricalInventory";
import ReportClosedGame from "../ReportViews/Pulltabs/ReportClosedGame";
import ReportCurrentInventory from "../ReportViews/Pulltabs/ReportCurrentInventory";
import ReportDeckStatus from "../ReportViews/Pulltabs/ReportDeckStatus";
import ReportDistributorGame from "../ReportViews/Pulltabs/ReportDistributorGame";
import ReportGameDefinition from "../ReportViews/Pulltabs/ReportGameDefinition";
import ReportMonthEnd from "../ReportViews/Pulltabs/ReportMonthEnd";
import ReportPulltabsCurrentPulltab from "../ReportViews/Pulltabs/ReportPulltabsCurrentPulltab";
import ReportSiteInventory from "../ReportViews/Pulltabs/ReportSiteInventory";
import Dashboard from "../ReportViews/RealTime/Dashboard";
import RealTimeLocationsStatus from "../ReportViews/RealTime/RealTimeLocationStatus";
import RealTimeTransactionLog from "../ReportViews/RealTime/RealTimeTransactionLog";
import LocationList from "../ReportViews/System/LocationList";
import POSBundleStatus from "../ReportViews/System/POSBundleStatus";
import StorageUsage from "../ReportViews/System/StorageUsage";
import UserList from "../ReportViews/System/UserList";
import ReportRevenueByPeriod from "../ReportViews/Analysis/ReportRevenueByPeriod";
import ReportRevenueByGame from "../ReportViews/Analysis/ReportRevenueByGame";
import Container from "../../components/Container";
import StorageUsageDetail from "../ReportViews/System/StorageUsageDetail";

interface IReportViewProps {
  type: string | null;
  title: string | null;
}

const getReportComponent = (type: string) => {
  const typeWithoutApiPrefix = type.replace("/api", "");

  switch (typeWithoutApiPrefix) {
    case "/reports-realtime/realtimetransactionlog":
      return <RealTimeTransactionLog />;
    case "/reports-pulltabs/historicalinventory":
      return <HistoricalInventory />;
    case "/reports-analysis/historicaltransactionlog":
      return <HistoricalTransactionLog />;
    case "/reports-realtime/realtimelocationstatus":
      return <RealTimeLocationsStatus />;
    case "/reports-realtime/dashboard":
      return <Dashboard />;
    case "/reports-pulltabs/closedpulltabgames":
      return <ReportClosedGame />;
    case "/reports-pulltabs/currentinventory":
      return <ReportCurrentInventory />;
    case "/reports-pulltabs/currentpulltabgames":
      return <ReportPulltabsCurrentPulltab />;
    case "/reports-pulltabs/deckstatus":
      return <ReportDeckStatus />;
    case "/reports-pulltabs/distributorgame":
      return <ReportDistributorGame />;
    case "/reports-pulltabs/locationinventory":
      return <ReportSiteInventory />;
    case "/reports-pulltabs/gamedefinition":
      return <ReportGameDefinition />;
    case "/reports-pulltabs/monthend":
      return <ReportMonthEnd />;
    case "/reports-system/locationlist":
      return <LocationList />;
    case "/reports-system/userlist":
      return <UserList />;
    case "/reports-system/posbundlestatus":
      return <POSBundleStatus />;
    case "/reports-system/storageusage":
      return <StorageUsage />;
    case "/reports-system/storageusagedetail":
      return <StorageUsageDetail />;
    case "/reports-analysis/revenuebydayofweek":
      return <ReportRevenueByDayOfWeek />;
    case "/reports-analysis/deviceutilization":
      return <ReportDeviceUtilization />;
    case "/reports-financial/cashieractivity":
      return <ReportCashierActivity />;
    case "/reports-financial/dailydeposit":
      return <ReportDailyDeposit />;
    case "/reports-financial/dailydepositsales":
      return <ReportDailyDepositSales/>;
    case "/reports-financial/dailysalesdetail":
      return <DailySalesDetail />;
    case "/reports-financial/periodrevenue":
      return <PeriodRevenue />;
    case "/reports-financial/monthlyreports":
      return <MonthlyReports />;
    case "/reports-financial/largecashoutactivity":
      return <LargeCashOut />;
    case "/reports-financial/lg861e":
      return <LocationLG861e />;
    case "/reports-analysis/gameperformance":
      return <ReportGamePerformance />;
    case "/reports-analysis/revenuebyperiod":
      return <ReportRevenueByPeriod />;
    case "/reports-analysis/revenuebygame":
      return <ReportRevenueByGame />;
    case "/reports-analysis/gameperformancewithvariants":
      return <ReportGamePerformanceWithVariants />;
    case "/reports-analysis/draweractivity":
      return <ReportDrawerActivity />;
    case "/reports-bingo/bingoaccount":
      return <BingoAccount />;
    case "/reports-bingo/bingocharityinvoice":
      return <BingoCharityInvoice />;
    case "/reports-bingo/bingodistributorstatement":
      return <BingoDistributor />;
    case "/reports-bingo/bingogamelog":
      return <BingoGameLog />;
    case "/reports-analysis/revenuebydevice":
      return <ReportRevenueByDevice />;
    case "/reports-bingo/bingocharitiesprogressivecontribution":
      return <ReportCharitiesProgressiveContribution />;
    case "/reports-bingo/bingolbpmonthly":
      return <BingoLBPMonthly />;
    case "/reports-bingo/bingoprogressivecontribution":
      return <BingoProgressiveContribution />;
    case "/reports-bingo/bingojackpotwinners":
      return <BingoJackpotWinners />;
    case "/reports-bingo/bingoactiveprogressives":
      return <BingoActiveProgressives />;
    case "/reports-bingo/bingoactivesites":
      return <BingoActiveSites />;
    case "/reports-bingo/bingoplay":
      return <ReportBingoPlay />;
    case "/reports-bingo/bingoperformance":
      return <ReportBingoPerformance />;
    default:
      return <>{type}</>;
  }
};

function ReportView(props: IReportViewProps) {
  return (
    <div className="report-view">
      <Container>
        <h4 className="report-view__title">{props.title || "Reports"}</h4>
      </Container>
      <div className="report-view__page">
        {props.type && getReportComponent(props.type)}
      </div>
    </div>
  );
}

export default ReportView;
